import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import { ConfirmButton } from 'components/buttons'

export const EmptyTrashButton = ({ canEmptyTrash, localize, emptyTrash, data }) => {
  const handleEmptyTrash = React.useCallback(() => emptyTrash(), [emptyTrash])
  if (canEmptyTrash && typeof emptyTrash === 'function') {
      return (
        <ConfirmButton isLoading={data.deleting} disabled={data.deleting} icon={<DeleteIcon />} width={220} color='secondary' confirmMessage={localize('common.confirmEmptyTrash')} onConfirm={handleEmptyTrash}>{localize('common.emptyTrash')}</ConfirmButton>
      )
    }
    return null
}
